import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeDebitsWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.debits",
  name: "Total debits",
  description: "Total debits for the selected dashboard period.",
  apps: [
    "home",
    "finance",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "debit",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Debits",
    subtext: "",
    icon: "money",
    color: "primary",
    valueFormat: "currency",
    valueMultiplier: 1,
  },
  dummyData: {
    value: "$148,500",
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
